import Vue from 'vue'
import Vuex from 'vuex'
import { apolloClient } from '../apollo'
import auth from './modules/auth'
import files from './modules/files'
import filters from './modules/filters'
import organization from './modules/organization'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    unsavedChanges: false
  },

  mutations: {
    setLoading (state, loading) {
      state.loading = loading
    },

    setUnsavedChanges (state, v) {
      state.unsavedChanges = v
    }
  },

  actions: {
    async graphqlQuery (context, { name, variables, ignoreCache = false }) {
      if (ignoreCache) {
        await context.dispatch('deleteStoreQuery', name, { root: true })
      }

      const result = await apolloClient.query({
        query: require(`../graphql/${name}.gql`),

        variables
      })

      if (result.errors && result.errors.length > 0) {
        console.error(result.errors)
        throw new Error(result.errors[0].message)
      }

      return result.data[name]
    },

    async graphqlMutation (context, { name, variables, deleteCacheQueries = [] }) {
      const result = await apolloClient.mutate({
        mutation: require(`../graphql/${name}.gql`),

        variables
      })

      if (result.errors && result.errors.length > 0) {
        console.error(result.errors)
        throw new Error(result.errors[0].message)
      }

      for (const q of deleteCacheQueries) {
        await context.dispatch('deleteStoreQuery', q, { root: true })
      }

      return result.data[name]
    },

    async deleteStoreQuery (context, name) {
      try {
        let rootQuery = apolloClient.cache.data.data.ROOT_QUERY

        Object.keys(rootQuery)
          .filter(query => query.indexOf(name) === 0)
          .forEach(query => {
            if (rootQuery[query]) delete rootQuery[query]
          })
      } catch (error) {
        // console.error(`deleteStoreQuery: ${error}`)
      }

      if (name === 'getOrganization') { // Special case because org is required on every page so it has no created() hooks that trigger after page load
        await context.dispatch('organization/fetchDetails')
      }
    }
  },

  modules: {
    auth,
    user,
    filters,
    organization,
    files
  }
})
